import {Button, Grid, MuiThemeProvider} from '@material-ui/core';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import React from 'react';
import {useDispatch} from 'react-redux';
import {editNewTask} from '../../../actions/tasks';
import TaskManyTable from '../../../modules/task/List/TaskManyTable';
import {colors} from '../../../ui/theme';
import green from '../../../ui/theme/green';
import CardContainer from '../../common/CardContainer';

function AddTaskButton({onClick}) {
  return (
    <>
      <MuiThemeProvider theme={green}>
        <Button
          onClick={onClick}
          variant={'contained'}
          color={'primary'}
        >
          Add Task
        </Button>
      </MuiThemeProvider>
    </>
  );
}

export const JobTasks = ({job}) => {
  const dispatch = useDispatch();

  const handleAddTask = () => {
    dispatch(editNewTask({
      jobIds: [job._id],
      jobs: [job]
    }));
  };

  return (
    <CardContainer
      title={'Tasks'}
      icon={<AssignmentTurnedInIcon />}
      iconBackgroundColor={colors.purple}
      buttonComponent={<AddTaskButton onClick={handleAddTask} />}
    >
      <Grid container>
        <Grid item xs={12} alignContent='center' justifyContent='center'>
          <TaskManyTable
            filterToMe={false}
            queryStateId={'jobTaskMany' + job._id}
            fixedFilter={{jobIds: [job._id]}}
          />
        </Grid>
      </Grid>
    </CardContainer>

  );
};

export default JobTasks;
